'use strict';

let ContentUtils,
  {t} = require('services/i18nextWrapper'),
    {
        REGEX_NAME_DEFAULT,
        TYPE_TANK_FERMENTER,
        TYPE_TANK_BRITE_TANK,
        TYPE_TANK_BREW_HOUSE,
        FERMENTER_TYPE_TASK,
        TYPE_TASK_FERMENTER,
        TYPE_TASK_PACKAGING,
        TYPE_TASK_BREWHOUSE,
        PACKAGING_TYPE_TASK,
        BREWING_TYPE_TASK,
        PACKAGING_SECTION_NAME,
        FERMENTING_SECTION_NAME,
        BREWING_SECTION_NAME,
        ITEM_CATEGORY_NON_INVENTORY
    } = require('constants/AppConstants'),
    localMemory = {},
    _ = require('lodash'),
    {max} = require('lodash/math'),
    {filter, map, some} = require('lodash/collection'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    DashboardAction = require('actions/DashboardActionCreators'),
    get = require('lodash/object').get,
    DateUtils = require('./DateUtils'),
    numeral = require('numeral'),
    getBoundingClientRect = require('bounding-client-rect'),
    singleAttributes = ['fromDate', 'toDate', 'singleTank'];

const BREWING_INFO = Object.freeze({
    className: 'is-brewhouse',
    classNameSection: 'brewing-icon',
    tankType: 'BH',
    tankTypeName: 'brewing',
    postFix: '_BH',
    postFixTaskType: 'BREWHOUSE_TASK',
    sectionName: 'Brewing',
    tasksFieldName: 'batchs',
    getMethodIcons: 'getBrewingProcess',
    getDays: 'currentBrewingDays',
    type: 'BH'
});

const FERMENTING_INFO = Object.freeze({
    className: 'is-fermenter',
    classNameSection: 'filtration-icon',
    tankType: 'FV',
    tankTypeName: 'fermenter',
    postFix: '',
    sectionName: 'Fermenting',
    postFixTaskType: 'FERMENTER_TASK',
    orderTankName: 'fermenterTank',
    tasksFieldName: 'fermenterTasks',
    getMethodIcons: 'getFermenterIcons',
    getDays: 'currentFermenterDays',
    type: 'FV'
});

const PACKAGING_INFO = Object.freeze({
    className: 'is-britetank',
    classNameSection: 'packaging-icon',
    tankType: 'BT',
    tankTypeName: 'packaging',
    postFix: '_BT',
    postFixTaskType: 'PACKAGING_TASK',
    orderTankName: 'briteTank',
    sectionName: 'Packaging',
    tasksFieldName: 'packagingTasks',
    getMethodIcons: 'getPackagingIcons',
    getDays: 'currentPackagingDays',
    type: 'BT'
});

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Helper class to handler the common/generic way the content in the browser, conditionals, cache handler,
 * queries element, cloning object, and other king of stuffs.
 */
ContentUtils = {


    isNull(value) {
        return _.isNull(value) ||
            _.isUndefined(value);
    },

    isEmptyText(value) {
        return this.isNull(value) || value === '';
    },

    isFunction(value) {
        return typeof value === 'function';
    },

    setTimeout(callback, after) {
        _.delay(callback, after);
    },

    isNullOrEmpty(value) {
        return _.isNull(value) ||
            _.isUndefined(value) ||
            '' === _.trim(value);
    },

    isNotNullOrUndefined(value) {
        return !_.isNull(value) &&
            !_.isUndefined(value);
    },

    trim(obj) {
        if (!this.isNullOrEmpty(obj)) {
            if (typeof obj === 'string') {
                return obj.trim();
            }
        }
        return obj;
    },

    isNullField(field, allowSpecialCharacter) {
        return _.isNull(field) ||
        _.isUndefined(field) ||
        _.isNull(field.getValue()) ||
        _.isUndefined(field.getValue()) ||
        field.getValue().trim() === '' ||
        allowSpecialCharacter ? false : !REGEX_NAME_DEFAULT.test(field.getValue());
    },

    isHidden(element) {
        return element.offsetParent === null;
    },

    offset(element) {
        if (!element) {
            return null;
        }
        var rect = getBoundingClientRect(element);

        return {
            top: rect.top + window.pageYOffset,
            left: rect.left + window.pageXOffset
        };
    },

    inViewport(element, container, customOffset) {
        if (this.isHidden(element)) {
            return false;
        }
        var top,
            left,
            bottom,
            right,
            containerOffset,
            elementOffset;
        if (typeof container === 'undefined' || container === window) {
            top = window.pageYOffset;
            left = window.pageXOffset;
            bottom = top + window.innerHeight;
            right = left + window.innerWidth;
        } else {
            containerOffset = this.offset(container);

            top = containerOffset.top;
            left = containerOffset.left;
            bottom = top + container.offsetHeight;
            right = left + container.offsetWidth;
        }

        elementOffset = this.offset(element);

        return (
            top < elementOffset.top + customOffset.bottom + element.offsetHeight &&
            bottom > elementOffset.top - customOffset.top &&
            left < elementOffset.left + customOffset.right + element.offsetWidth &&
            right > elementOffset.left - customOffset.left
        );

    },

    pushSafe(array, item) {
        if (array && array.length) {
            array.push(item);
            return array;
        } else {
            return [];
        }
    },

    /**
     *  Retrieve is Chrome * Safari ≥ 3 Opera ≥ 14
     * @returns {boolean}
     */
    isWebkit() {
        return 'WebkitAppearance' in document.documentElement.style;
    },

    isWindows() {
        return navigator.platform.indexOf('Win') > -1;
    },

    /**
     * Check if given two object (with the same properties), have the same values
     * in each of the properties. Also optionally could check equality for specific set of properties.
     *
     * @param {Object} objectA  Object to be compare against to ObjectB.
     * @param {Object} objectB  Object to be compare against to ObjectA.
     * @param {Array} onlyProperties (Optional) just compare only the given property of each of object.
     * @private
     */
    isSameObject(objectA, objectB, onlyProperties) {
        if (objectA && objectB) {
            var props = Object.keys(objectA);

            if (onlyProperties && onlyProperties.length > 0) {
                props = props.filter(function (prop) {
                    return onlyProperties.indexOf(prop) > -1;
                });
            }

            return props.every(function (prop) {
                if (objectA[prop] && objectB[prop]) {
                    return objectA[prop] === objectB[prop];
                }
                return false;
            });
        }
    },

    /**
     * Given a collection and one register, search and replace the new register for the older.
     * @param list
     * @param newItem
     * @param matchAttribute
     * @returns {Array}
     * @private
     */
    replace(list, newItem, matchAttribute) {
        const newList = _.filter(list, oldTask => _.get(oldTask, matchAttribute) !== _.get(newItem, matchAttribute));
        newList.push(newItem);
        return newList;
    },
    
    /**
     * Given a collection and a list of register, search and replace each new register for the older.
     * @param list
     * @param newItems
     * @param matchAttribute
     * @returns {Array}
     * @private
     */
    replaceAll(list, newItems, matchAttribute) {
        if (list && newItems && list.length && newItems.length) {
            for(let i = 0; i < newItems.length; i++) {
                list = this.replace(list, newItems[i], matchAttribute);
            }
        }
        return list;
    },

    /**
     * Given a collection and one register, search and replace the new register for the older.
     * @param list
     * @param newItem
     * @param matchAttribute
     * @returns {Array}
     * @private
     */
    replaceByAttributes(list, newItem, matchAttributes) {

        if (!Array.isArray(matchAttributes)) {
            // force to always be an array in order to work the following `every` command
            matchAttributes = [matchAttributes];
        }

        if (this.isNullOrEmpty(list)) {
            return list;
        }

        const hasSomeAttributeToCompare = some(matchAttributes, matchAttr => Object.keys(list[0]).indexOf(matchAttr) > -1);
        if (!hasSomeAttributeToCompare) {
            // enter here means that any of the attributes match
            return list;
        }

        let filteredItems = _.filter(list, oldTask => {
            // filter only items which match all attributes equals
            return !_.every(matchAttributes, matchAttribute => _.get(oldTask, matchAttribute) === _.get(newItem, matchAttribute));
        });

        filteredItems.push(newItem);
        return filteredItems;
    },

    /**
     * Given a collection and a list of register, search and replace the news register for the olders.
     * @param listWillRemoveDuplicated
     * @param listToCompare
     * @param matchAttribute
     * @returns {Array}
     * @private
     */
    removeDuplicatedList(listWillRemoveDuplicated, listToCompare, matchAttribute) {
        const itemsToFilter = _.map(listToCompare, newItem => _.get(newItem, matchAttribute));
        return _.filter(listWillRemoveDuplicated, oldTask => !_.includes(itemsToFilter, _.get(oldTask, matchAttribute)));
    },

    /**
     * Search a specific node element and return it from the component.
     * @param {HTMLElement}  component  is the component which could have searched target.
     * @param {String} className        is the class of the component to be searched.
     * @returns {HTMLElement} The component searched.
     */
    getComponentByClassName(component, className) {
        while (component && component.classList && !component.classList.contains(className)) {
            component = component.parentNode;
        }
        return component;
    },

    /**
     * Remove some item which match with {@code objectMatcher} param.
     * @param list
     * @param objectMatcher
     * @return {*}
     */
    removeItemByObjectEquality(list, objectMatcher) {
        return _.filter(list, item => {
            const attrFields = Object.keys(objectMatcher);
            const isTargetItem = _.every(attrFields, attribute => item[attribute] === objectMatcher[attribute]);
            return !isTargetItem;
        });
    },

    setAttribute(obj, attr, value) {
        if (attr.includes('.')) {
            const allAttributes = attr.split('.');
            const firstAttribute = allAttributes[0];
            return this._setAttribute(obj, firstAttribute, allAttributes, value);
        } else {
            return obj[attr] = value;
        }
    },

    _setAttribute(obj, attribute, attributes, value) {

        const currentIndexAttribute = attributes.indexOf(attribute);

        if (!obj) {
            obj = {};
        }

        const isLastAttribute = (currentIndexAttribute + 1) === attributes.length;

        if (isLastAttribute) {
            // leaf attribute
            obj[attribute] = value;
        } else {
            // going deeper
            const nextObj = obj[attribute];
            const nextAttribute = attributes[currentIndexAttribute + 1];
            obj[attribute] = this._setAttribute(nextObj, nextAttribute, attributes, value);
        }

        return obj;
    },

    /**
     * Search a specific node element and return it from the component.
     * @param {HTMLElement}  component  is the component which could have searched target.
     * @param {String} attribute    is the name of the attribute target.
     * @returns {HTMLElement} The component searched.
     */
    getComponentByAttribute(component, attribute) {
        while (component && component.hasAttribute && !component.hasAttribute(attribute)) {
            component = component.parentNode;
        }
        return component;
    },

    /**
     * Search a specific node element and return it from the component.
     * @param {HTMLElement}  component      is the component which could have searched target.
     * @param {String} targetTagName        is the component name to be searched.
     * @returns {HTMLElement} The component searched.
     */
    getComponentByElement(component, targetTagName) {
        while (component && component.tagName !== targetTagName) {
            component = component.parentNode;
        }
        return component;
    },

    /**
     * The safe way to clone an object and lose their reference.
     * @argument {Object} value     is the object that will be cloned.
     * @return {Object} The clone object.
     */
    clone(value) {
        if (!value) {
            return null;
        } else {
            return JSON.parse(JSON.stringify(value));
        }
    },

    /**
     * Set given pair key value data into session storage.
     * @param {String} key
     * @param {Object} value
     */
    saveSession(key, value) {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch(err) {
            if (err.message.includes('exceeded the quota')) {
                CustomDialog.showWarningConfirmation(t('warning'), t('notification_draft_maximum_capacity_publish'), () => {
                    DashboardAction.publishingDraft();
                });
            }
        }
    },

    /**
     * Retrieve value from local session data from given key.
     * @param {String} key
     * @return {Object}
     */
    getSession(key) {
        if (sessionStorage.getItem(key) && sessionStorage.getItem(key) !== 'undefined') {
            return JSON.parse(sessionStorage.getItem(key));
        } else {
            return '';
        }
    },

    /**
     * Set given pair key value data into local storage.
     * @param {String} key
     * @param {Object} value
     */
    saveLocal(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },


    /**
     * Set given pair key value data into local memory.
     * @param {String} key
     * @param {Object} value
     */
    saveMemory(key, value) {
        localMemory[key] = value;
    },

    /**
     * Retrieve value from local memory data from given key.
     * @param {String} key
     * @return {Object}
     */
    getMemory(key) {
        return localMemory[key];
    },

    /**
     * Retrieve value from local session data from given key.
     * @param {String} key
     * @return {Object}
     */
    getLocal(key) {
        if (localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined') {
            return JSON.parse(localStorage.getItem(key));
        } else {
            return '';
        }
    },

    /**
     * Filter event argument from arrays of arguments.
     * @param arguments
     * @return {*|Array}
     */
    filterEvents(args) {
        if (args) {
            return _.find(args, function (argument) {
                return argument && argument.eventPhase && argument.target;
            });
        }
    },

    /**
     * Sort given list objets by given attribute
     * @param list
     * @param attr
     * @returns {*}
     */
    sortList(list, attr) {
        var a, b, a1, b1, rx = /(\d+)|(\D+)/g, rd = /\d+/;

        if (list === undefined || list.sort === undefined) {
            return list;
        }

        return (list || []).sort(function (as, bs) {
            a = String(_.get(as, attr)).toLowerCase().match(rx);
            b = String(_.get(bs, attr)).toLowerCase().match(rx);
            while (a.length && b.length) {
                a1 = a.shift();
                b1 = b.shift();
                if (rd.test(a1) || rd.test(b1)) {
                    if (!rd.test(a1)) return 1;
                    if (!rd.test(b1)) return -1;
                    if (a1 != b1) return a1 - b1;
                }
                else if (a1 != b1) return a1 > b1 ? 1 : -1;
            }
            return a.length - b.length;
        });
    },

    sortListDesc(list, attr) {
        return _.orderBy(list, [attr], ['desc']);
    },

    sortListByValue(list, attr, value) {
        if (this.isNotEmptyArray(list)) {
            return _.sortBy(list, fieldOne => get(fieldOne, attr) === value ? -1 : 1);
        } else {
            return list;
        }
    },

    filterNumbers(arrays) {
        if (this.isNotEmptyArray(arrays)) {
            return _.filter(arrays, obj => {
                const isNumber = (typeof obj === 'number');
                return !isNumber;
            });
        }
        return arrays;
    },

    /**
     * Return the duplicate register from given list.
     * @param list
     * @returns {Array.<T>}
     */
    getDuplicates(list) {
        var uniq = list.map(function (name) {
            return {count: 1, name: name};
        }).reduce(function (a, b) {
            a[b.name] = (a[b.name] || 0) + b.count;
            return a;
        }, {});

        return Object.keys(uniq).filter(function (a) {
            return uniq[a] > 1;
        });
    },

    /**
     * Retrieve the non-duplicate register from given list.
     * @param list
     * @returns {Array.<T>}
     */
    getNonDuplicates(list) {
        var uniq = list.map(function (name) {
            return {count: 1, name: name};
        }).reduce(function (a, b) {
            a[b.name] = (a[b.name] || 0) + b.count;
            return a;
        }, {});

        return Object.keys(uniq).filter(function (a) {
            return uniq[a] === 1;
        });
    },

    /**
     * Retrieve the properly format of error code.
     * @param message
     * @returns {string}
     */
    formatMessageError(message) {
        return message && message.indexOf('|') > -1 ? message.substring(0, message.indexOf('|')).trim() : message;
    },

    /**
     * Given field component, check empties condition.
     * @param value
     * @returns {*|boolean}
     */
    isEmptyField(value) {
        return _.isNull(value) ||
            _.isUndefined(value) ||
            value.getValue === undefined ||
            _.isNull(value.getValue()) ||
            _.isUndefined(value.getValue()) ||
            value.getValue().trim() === '';
    },

    isValidText(text, fieldName) {
        if (_.isNull(text) || _.isUndefined(text) || text === '') {
            return `${fieldName} ${t('notification_is_required')}`;
        } else if (!REGEX_NAME_DEFAULT.test(text)) {
            return `${t('notification_error_invalid_character')}`;
        } else if (text.length < 1) {
            return `${t('notification_label_the')} ${ fieldName } ${t('notification_is_too_small')}`;
        } else if (text.length > 90) {
            return `${t('notification_label_the')} ${fieldName} ${t('notification_is_too_long')}`;
        }
        return '';
    },

    isValidTextNotRequired(text, fieldName) {
        if (_.isNull(text) || _.isUndefined(text) || text === '') {
            return '';
        } else if (!REGEX_NAME_DEFAULT.test(text)) {
            return `${t('notification_error_invalid_character')}`;
        } else if (text.length < 1) {
            return `${t('notification_label_the')} ${ fieldName } ${t('notification_is_too_small')}`;
        } else if (text.length > 90) {
            return `${t('notification_label_the')} ${fieldName} ${t('notification_is_too_long')}`;
        }
        return '';
    },

    isValidTextNotRequiredWithCustomValidation(text, fieldName, customRegex = REGEX_NAME_DEFAULT) {
        if (_.isNull(text) || _.isUndefined(text) || text === '') {
            return '';
        } else if (!customRegex.test(text)) {
            return `${t('notification_error_invalid_character')}`;
        } else if (text.length < 1) {
            return `${t('notification_label_the')} ${ fieldName } ${t('notification_is_too_small')}`;
        } else if (text.length > 90) {
            return `${t('notification_label_the')} ${fieldName} ${t('notification_is_too_long')}`;
        }
        return '';
    },

    isEmptyArray(array) {
        return _.get(array, 'length', 0) === 0;
    },

    isNotEmptyArray(array) {
        return _.get(array, 'length', 0) > 0;
    },

    stringifyObject(obj) {
        if (!obj) {
            return;
        }

        // open obj
        let objString = '{';

        for (let property in obj) {
            objString += property;
            objString += ':';
            objString += typeof obj[property] === 'string' ? '"' + obj[property] + '"' : obj[property];
            objString += ',';
        }

        // remove the last ','
        objString = objString.substring(0, objString.length - 1);

        // close obj
        objString += '}';

        return objString;
    },

    /**
     * Remove item duplicate, checking equality by given attributes.
     * @param array
     * @param props
     * @return {*}
     */
    removeDuplicateByAttribute(array, props) {

        if (_.get(array, 'length', 0) === 0 || _.get(props, 'length', 0) === 0) {
            return array;
        }

        let nonDuplicates = [];

        for (const obj of array) {
            const isDuplicate = _.some(nonDuplicates, target => this.isSameObject(target, obj, props));
            if (!isDuplicate) {
                nonDuplicates.push(obj);
            }
        }

        return nonDuplicates;
    },

    /**
     * Retrieve in safe way the number of given string
     * @param order
     * @return {number}
     */
    getNumber(number, defaultResult = 0) {
        if (typeof number === 'number') {
            return number;
        }
        if (!number) {
            return defaultResult;
        }
        if (number && number.match) {
            return +_.join(number.match(/[\d]/gi), '');
        } else {
            return defaultResult;
        }
    },

    /**
     * Retrieve the object of given string content.
     * @param {String} content The content that will be parsed
     * @param {String} field (Optionally)
     * @return {Object}
     */
    parse(content, field) {
        if (!content) {
            return content;
        }

        try {
            if (field) {
                const resultContent = _.get(content, field);
                return typeof resultContent === 'string' ? JSON.parse(resultContent) : resultContent;
            } else {
                return typeof content === 'string' ? JSON.parse(content) : content;
            }
        } catch (e) {
            console.error(e.message);
            return content;
        }
    },

    /**
     * Convert given object to another serialized string object.
     *
     * @param {Object} obj                                  The Object that will be serialized
     * @param {Boolean} stringifyManually (Optionally)      The Object that will be serialized
     * @return {String}                                     The serialized object.
     */
    stringify(obj, stringifyManually = false) {
        if (!obj) {
            return;
        }

        if (!stringifyManually) {
            // by default the we stringify an traditional way
            try {
                return JSON.stringify(obj);
            } catch (e) {
                console.warn('The common way of stringify is not working, fall back to manual way...');
            }
        }

        // following here means that traditional way of stringify does'n worked. So we make a manual shallow serialization of given object.

        // open obj
        let objString = '{';

        for (let property in obj) {
            objString += property;
            objString += ':';
            objString += typeof obj[property] === 'string' ? '"' + obj[property] + '"' : obj[property];
            objString += ',';
        }

        // remove the last ','
        objString = objString.substring(0, objString.length - 1);

        // close obj
        objString += '}';

        return objString;
    },

    /**
     * Given an number or string extract the order id that contain.
     * @param {String} dirtyId       The id that could have string  format with '_BT' prefix or just the number
     * @return {String}
     */
    cleanId(orderId) {
        if (orderId) {

            if (!orderId || typeof orderId === 'number') {
                return null;
            }

            if (this.isBT(orderId)) {
                return orderId.substring(0, orderId.length - 3);
            } else if (this.isBH(orderId)) {
                return orderId.substring(0, orderId.indexOf('_BH'));
            } else {
                return orderId;
            }
        }
        return null;
    },

    isBT(id) {
        return _.includes(id, 'BT');
    },

    isBH(id) {
        return _.includes(id, 'BH');
    },

    isBHOnly(id) {
        return !this.isBHBatch(id) && _.includes(id, 'BH');
    },

    isBHBatch(id) {
        return _.includes(id, 'BH|');
    },

    isSingle(order) {
        for (const field in order) {
            if (_.includes(singleAttributes, field)) {
                return true;
            }
        }
        return false;
    },

    /**
     * Standardize the way to access information of Combined and Single Orders.
     * @param order
     * @param mappingFieldName
     * @return {*}
     */
    getOrderField(order, mappingFieldName, type, offsetDays = 0) {
        if (!order) {
            return;
        }

        let mappingFields;

        if (order && order.isSingle) {
            mappingFields = {
                startDate: 'fromDate',
                endDate: 'toDate'
            };
        } else {
            if (this.isBT(type || order.i)) {
                mappingFields = {
                    startDate: 'filtrationDate',
                    endDate: 'orderDate'
                };
            } else {
                mappingFields = {
                    startDate: 'brewDate',
                    endDate: 'filtrationDate'
                };
            }
        }

        const dateWithoutOffset = _.get(order, mappingFields[mappingFieldName]);
        return DateUtils.addDaysTextBasicFormat(dateWithoutOffset, offsetDays);
    },

    getTankTypeConfiguration(tankType) {
        switch (tankType) {
            // BY TANK TYPE
            case TYPE_TANK_FERMENTER:
                return FERMENTING_INFO;
            case TYPE_TANK_BRITE_TANK:
                return PACKAGING_INFO;
            case TYPE_TANK_BREW_HOUSE:
                return BREWING_INFO;
            // BY TASK TYPE
            case FERMENTER_TYPE_TASK:
                return FERMENTING_INFO;
            case TYPE_TASK_FERMENTER:
                return FERMENTING_INFO;
            case PACKAGING_TYPE_TASK:
                return PACKAGING_INFO;
            case TYPE_TASK_PACKAGING:
                return PACKAGING_INFO;
            case BREWING_TYPE_TASK:
                return BREWING_INFO;
            case TYPE_TASK_BREWHOUSE:
                return BREWING_INFO;
            case 'Brewing':
                return BREWING_INFO;
        }
    },

    /**
     * This kind of order should not exists. The main of this method is to provide to
     * the user the way to delete this kind of order without change it.
     * @param order
     * @return {boolean}
     */
    isGhostOrder(order) {
        if (order) {
            if (order.isSingle) {
                return !!order.singleTank === false;
            } else {
                return !!order.briteTank === false || !!order.fermenterTank === false;
            }
        }
    },

    /**
     * Just format properly the name of duplicated of given name.
     *
     * @param {String} name     Which will be duplicated
     * @return {String}
     */
    formatDuplicateName(name) {
        return `${name} - ${t('label_copy')}`;
    },

    formatApplicantIcons(allIcons, applicantIcons) {
        const applicantIconsIds = _.map(applicantIcons, applicationIcon => _.get(applicationIcon, 'icon.id', _.get(applicationIcon, 'id')));
        const allIconsWithoutApplicantIcon = _.filter(allIcons, icon => !_.includes(applicantIconsIds, _.get(icon, 'id')));
        const allIconsHydratedWithApplicantIcon = _.concat(allIconsWithoutApplicantIcon, applicantIcons);
        return allIconsHydratedWithApplicantIcon;
    },

    markProductIcons(allIconsWithApplicantIcons, productIcons) {
        const productIconsId = _.map(productIcons, productIcon => _.get(productIcon, 'id'));

        return _.map(allIconsWithApplicantIcons, icon => {
            if (_.includes(productIconsId, icon.id)) {
                icon.isProductIconChecked = true;
            } else {
                icon.isProductIconChecked = false;
            }
            return icon;
        });
    },

    retrieveNextItemCode(items, item, itemCodeModule, categoryField = 'category') {
        const itemCodeCategory = get(item, categoryField, '').substring(0, 2).toUpperCase(); //  acronym of Item module
        const itemsWhitSameCategory = filter(items, itemFilter => get(itemFilter, categoryField) === get(item, categoryField));
        const codeItemsWithSameCategory = map(itemsWhitSameCategory, itemMapped => ContentUtils.getNumber(itemMapped.code));
        const isFirstItem = codeItemsWithSameCategory.length === 0;
        const nextNumber = isFirstItem ? 1 : max(codeItemsWithSameCategory) + 1;
        const nextItemCode = `${itemCodeModule}${itemCodeCategory}${nextNumber}`;

        return nextItemCode;
    },

    getRandomId() {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    },

    /**
     * Check if given {@param value} if are string or number.
     * @param {Object || Array} value
     * @return {boolean}
     */
    isStringOrIntegerItem(value) {
        if (value === undefined || value === null) {
            return false;
        }

        return typeof value[0] === 'string' ||
            typeof value[0] === 'number' ||
            typeof value === 'number' ||
            typeof value === 'string';
    },
    

    filterDisableTankDisabledIfNotHaveOrder(tanks, orders) {
        const existSomeDisabledTank = _.some(tanks, tank => _.get(tank, 'enable') === false);
        
        if (existSomeDisabledTank) {
            // map tanks id which are disabled
            const tanksIdDisabled = getTanksIdDisabled(tanks);
            const tanksIdFromOrders = getTanksIdFromOrders(orders);
            // search if some disabled tank is related from
            // some order of current page
            const tanksDisabledShouldBeVisible = _.intersection(tanksIdDisabled, tanksIdFromOrders);
            const existSomeTankDisabledWhichNeedToBeVisible = ContentUtils.isNotEmptyArray(tanksDisabledShouldBeVisible);

            if (!existSomeTankDisabledWhichNeedToBeVisible) {
                // enter here means we filter all tanks disabled
                // because we don't need theirs
                const tanksEnable = _.filter(tanks, tank => _.get(tank, 'enable') === true || _.get(tank, 'enable') === undefined);
                return tanksEnable;
            }

            return _.filter(tanks, tank => {
                const isDisabledTank = _.get(tank, 'enable') === false;
                if (isDisabledTank) {
                    const tankId = _.get(tank, 'id');
                    const isNeededToBeVisible = tanksDisabledShouldBeVisible.includes(tankId);
                    return isNeededToBeVisible;
                } else {
                    // is enable, this tank we need to return it.
                    return true;
                }
            });
        } else {
            // enter here means non exist disable tanks, so we
            // don't need to filter any tank, just by section if needed.
            return tanks;
        }
    },
    
    filterTanksBySections(tanks, {
                      isVisibleBrewingSection,
                      isVisibleFermentingSection,
                      isVisiblePackagingSection
                   }) {
        return (tanks || []).filter(tank => {
           return isVisibleBrewingSection && tank.type === 'BH' ||
             isVisibleFermentingSection && tank.type === 'FV' ||
             isVisiblePackagingSection && tank.type === 'BT';
        });
    },
    
    getNewColumnSingleBySection(order, tanks, {
                                   isVisibleBrewingSection,
                                   isVisibleFermentingSection,
                                   isVisiblePackagingSection
                               }) {
        let column = get(order, 'singleTank.column');
        const amountBH = tanks.filter(t => t.type === 'BH').length;
        const amountFV = tanks.filter(t => t.type === 'FV').length;
  
        if (!isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection && order.currentSection === 'BT') {
            column = column - (amountBH + amountFV) >= 0
              ? column - (amountBH + amountFV)
              : column;
        } else if (isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection && order.currentSection === 'BT') {
            column = column - amountFV >= 0
              ? column - amountFV
              : column;
        } else if (!isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection) {
            column = column - amountBH >= 0
              ? column - amountBH
              : column;
        } else if (!isVisibleBrewingSection && isVisibleFermentingSection && !isVisiblePackagingSection && order.currentSection === 'FV') {
            column = column - amountBH >= 0
              ? column - amountBH
              : column;
        }
        
        return column;
    },
    
    getColumnsByCombinedOrderForFermenting(state, xPosition) {
        const {
            isVisibleBrewingSection,
            isVisibleFermentingSection,
            isVisiblePackagingSection,
            tanks
        } = state;
        const amountBH = tanks.filter(t => t.type === 'BH').length;
        const amountFV = tanks.filter(t => t.type === 'FV').length;
        
        if (!isVisibleBrewingSection && isVisibleFermentingSection && !isVisiblePackagingSection) {
            return xPosition - amountBH;
        }
        
        if (!isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection) {
            return xPosition - amountBH;
        }
        
        if (!isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection) {
            return xPosition - (amountBH + amountFV);
        }
        
        return xPosition;
    },
    
    getColumnsByCombinedOrderForPackaging(state, xPosition) {
        const {
            isVisibleBrewingSection,
            isVisibleFermentingSection,
            isVisiblePackagingSection,
            tanks
        } = state;
        const amountBH = tanks.filter(t => t.type === 'BH').length;
        const amountFV = tanks.filter(t => t.type === 'FV').length;
        
        if (isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection) {
            return xPosition - amountFV;
        }
        if (!isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection) {
            return xPosition - (amountFV + amountBH);
        }
        if (!isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection) {
            return xPosition - amountBH;
        }
        
        return xPosition;
    },

    filterEnable(items) {
        return filter(items, item => {
            const stateAttribute = getStateAttribute(item);

            return _.get(item, stateAttribute) === true || // is defined by the user
                _.get(item, stateAttribute) === undefined || // 'undefined' means is non defined yet, so by default is enable
                _.get(item, stateAttribute) === null; // 'null' means is non defined yet, so by default is enable
        });
    },

    filterEnableByAttribute(items, attributes) {
        return filter(items, item => {
            const isSomeDisable = _.some(attributes, attribute => _.get(item, attribute) === false);
            return isSomeDisable ? false:true;
        });
    },

    getAmountPageNeeded(totalAmount, maxAmountPerPage) {
        let totalAmountPages = 0;
        if (totalAmount < maxAmountPerPage) {
            return totalAmountPages;
        }

        totalAmountPages++;
        if (totalAmount % maxAmountPerPage > 0) {
            const resultDivision = numeral(totalAmount).divide(maxAmountPerPage).value();
            return Math.trunc(resultDivision) + 1;
        } else {
            return numeral(totalAmount).divide(maxAmountPerPage).value();
        }
    },

    /**
     * This particular case exist because in some scenarios we need to know about the task of each product which come from,
     * so it's only some specific needed for a short period of time (when need calculate inventory and other stuff), in order
     * to be serializable again given list of task (avoid circular references), should be cleaned this reference.
     *
     * @param tasks
     * @returns {Array}
     */
    cleanAllTasksOfProducts(tasks) {
        return _.map(tasks, task => {
            if (!task || ContentUtils.isEmptyArray(get(task, 'products'))) {
                return task;
            }
            task.products = _.map(_.get(task, 'products'), product => {
                product.task = null;
                return product;
            });
            return task;
        });
    },

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    formatMessage(string) {
        return this.capitalizeFirstLetter(string.replace(/_/g, ' ').toLowerCase());
    },

    isEqualByAttributes(listOne, listTwo, attributes) {
        return _.every(listOne, item => {
            return _.some(listTwo, itemCompare => {
                return _.every(attributes, attribute => {
                    return itemCompare[attribute] === item[attribute];
                });
            });
        });
    },

    isValidEmail(email) {
        return EMAIL_REGEX.test(String(email).toLowerCase());
    },

    sortTanksAndAddColumn(tanks) {
        var briteTanks,
            fermenterTanks,
            sortedTanks,
            brewhouseTanks;
        if (tanks) {
            // Group by type tanks.
            briteTanks = _.filter(tanks, function (tank) {
                return tank.type === TYPE_TANK_BRITE_TANK;
            });
            fermenterTanks = _.filter(tanks, function (tank) {
                return tank.type === TYPE_TANK_FERMENTER;
            });

            brewhouseTanks = _.filter(tanks, function (tank) {
                return tank.type === TYPE_TANK_BREW_HOUSE;
            });

            // Add sections field names
            briteTanks = _.map(briteTanks, tank => {
                tank.section = PACKAGING_SECTION_NAME;
                return tank;
            });
            fermenterTanks = _.map(fermenterTanks, tank => {
                tank.section = FERMENTING_SECTION_NAME;
                return tank;
            });
            brewhouseTanks = _.map(brewhouseTanks, tank => {
                tank.section = BREWING_SECTION_NAME;
                return tank;
            });

            // Sort each type of group by their number
            fermenterTanks = ContentUtils.sortList(fermenterTanks, 'name');
            briteTanks = ContentUtils.sortList(briteTanks, 'name');
            brewhouseTanks = ContentUtils.sortList(brewhouseTanks, 'name');

            // The order that concat will change the order of visible tanks, eg fist brewhouse,
            sortedTanks = _.concat(brewhouseTanks, fermenterTanks, briteTanks);

            //Assign column attribute
            sortedTanks = map(sortedTanks, function (tank, index) {
                tank.column = index;
                return tank;
            });
            return sortedTanks;
        } else {
            return tanks;
        }
    },

    getItemId(obj) {
        return _.get(obj, 'itemId') || _.get(obj, 'item.id') || _.get(obj, 'id');
    },

    filterNonInventoryItems(items) {
        return _.filter(items, item => _.get(item, 'category') !== ITEM_CATEGORY_NON_INVENTORY);
    },/*
  
    /**
     * Get color (black/white) depending on bgColor so it would be clearly seen.
     * @param bgColor
     * @returns {string}
     */
    getColorByBgColor(bgColor) {
        if (!bgColor) bgColor = '';
        
        const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
        const r = parseInt(color.substring(0, 2), 16); // hexToR
        const g = parseInt(color.substring(2, 4), 16); // hexToG
        const b = parseInt(color.substring(4, 6), 16); // hexToB
        return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
          '#000' : '#fff';
    },
    
    sortIcons(items) {
        return _.sortBy(items.map(item => {
            item.sortOrder = getIconSortOrder(item.name);
            return item;
        }), 'sortOrder', ['desc']);
    },
    getIconText(text) {
        return getIconData(text).icon;
    }
};

function getIconSortOrder(text) {
    return getIconData(text).sortOrder;
}

function getIconData(text) {
    if (!text) {
        text = '';
    }
    if (text.match(/VISIBILITY/)) {
        return {icon: 'visibility', sortOrder: 0};
    } else if (text.match(/NEW/)) {
        return {icon: 'add', sortOrder: 2};
    } else if (text.match(/EDIT/) ||
      text === 'ADMIN_INVENTORY_AND_TRANSFERS_TRANSFER_SHOW' ||
      text === 'ADMIN_INVENTORY_AND_TRANSFERS_ADJUST_SHOW'
    ) {
        return {icon: 'mode_edit', sortOrder: 3};
    } else if (text.match(/DELETE/)) {
        return {icon: 'remove', sortOrder: 4};
    } else if (text.match(/PRINT/)) {
        return {icon: 'print', sortOrder: 5};
    } else if (text.match(/CONFIRM/)) {
        return {icon: 'done', sortOrder: 7};
    } else if (text.match(/SEND/)) {
        return {icon: 'send', sortOrder: 8};
    } else if (text.match(/ADMIN_REPORT/) && text !== 'ADMIN_REPORT_SHOW') {
        return {icon: 'file_download', sortOrder: 9};
    } else if (text.match(/DUPLICATE/) ||
      text === 'ADMIN_PRODUCT_DUPLICATE_SHOW'
    ) {
        return {icon: 'content_copy', sortOrder: 6};
    } else if (text.match(/SHOW/)) {
        return {icon: 'visibility', sortOrder: 1};
    } else {
        return {icon: 'visibility', sortOrder: 0};
    }
}


/**
 * Return the name of the state attribute.
 * @param item
 * @return {*}
 */
function getStateAttribute(item) {
    const value = _.get(item, 'enable');
    const isDefined = value !== null && value !== undefined;

    if (isDefined) {
        return 'enable';
    } else {
        return 'isEnable';
    }
}

function getTanksIdDisabled(tanks) {
    return _.map(_.filter(tanks, tank => _.get(tank, 'enable') === false), tank => tank.id);
}

function getTanksIdFromOrders(orders) {
    return _.flatten(_.map(orders, order => {
        let tanksId = [];
        const isSingleOrder = order && order.isSingle === true;
        const haveBatchs = order && ContentUtils.isNotEmptyArray(order.batchs);

        if (isSingleOrder) {
            tanksId.push(order.singleTankId);
        } else {
            tanksId.push(order.briteTankId);
            tanksId.push(order.fermenterTankId);
        }
        // add id of all turns
        if (haveBatchs) {
            for (const batch of order.batchs) {
                const turnId = _.get(batch, 'turnId');
                tanksId.push(turnId);
            }
        }

        return tanksId;
    }));

}

module.exports = ContentUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/ContentUtils.js
 **/